import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useTracker } from '@/core/tracking';
import { mediaShownInComparerState, mediaState } from '@/stores/mediaStore';
import settingsState from '@/stores/settingsStore';

export const useTrackProcessedImageEvents = () => {
  const media = useRecoilValue(mediaState);
  const mediaInComparer = useRecoilValue(mediaShownInComparerState);
  const { track } = useTracker();
  const settings = useRecoilValue(settingsState);

  useEffect(() => {
    if (media.id && settings) {
      if (typeof media.id === 'undefined' || media.id === '') {
        return;
      }

      if (media.isUnavailable) {
        track('processed_image', 'unavailable');
      } else {
        const { aiPipeline = {} } = mediaInComparer;

        track('processed_image', 'shown', {
          hasWatermark: mediaInComparer.hasWatermark,
          aiPipeline,
        });
      }
    }
  }, [media, settings, track, mediaInComparer]);
};
